import axios from "axios";

import { env } from "@/config/env";
import {
  errorResponse,
  languageInterceptor,
  privateRequest,
} from "./interceptors";

/**
 * @deprecated use `api/parsers.ts` instead
 */
export interface ServiceResponse<T> {
  status: number;
  success: boolean;
  data: T;
  pagination?: {
    total: number;
    perPage: number;
    currentPage: number;
    totalPages: number;
    hasMorePagesBefore?: boolean;
    hasMorePagesAfter?: boolean;
  };
}

const baseConfig = {
  baseURL: env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
};

export const publicAPI = axios.create(baseConfig);
export const privateAPI = axios.create(baseConfig);

publicAPI.interceptors.request.use(languageInterceptor);
privateAPI.interceptors.request.use(languageInterceptor);

privateAPI.interceptors.request.use(privateRequest);
privateAPI.interceptors.response.use((response) => response, errorResponse);
